import { getUserAddresses } from '@/services/checkout';
import { getCookie } from 'cookies-next';
import { useTranslations } from 'next-intl';
import useSWR from 'swr';
import HomeDeliveryAddressCard from '../../../cards/delivery-address-card';

import { Button } from '@/components/ui/buttons';
import PlusIcon from '@/components/ui/icons/plus-icon';
import ShopIcon from '@/components/ui/icons/shop-icon';
import { useState } from 'react';

import { SHIPPING_INFO_MODALS_NAMES } from '@/constants';
import { event_button_click, event_new_address } from '@/utils/gtm';
import AddressOptionSkeleton from '../../../cards/AddressOptionSkeleton';

const DeliveryAddressModal = ({
  setModalStep,
  setShippingMethod,
  handleOnClose,
  setShippingAddress,
  shippingAddress,
  setSelectedAddress,
  setAddressType,
}) => {
  const mage = getCookie('mage');
  const t = useTranslations('modals');

  const {
    data: userAddress,
    isLoading,
    mutate,
  } = useSWR(`userAddress/${mage}`, () => getUserAddresses(mage));

  const [selectedOption, setSelectedOption] = useState(shippingAddress);

  return (
    <>
      <div className='px-[29px] pt-[14px] max-sm:px-1.75'>
        <p className='max-sm:text-xs'>
          {t('Products available at your current location')}
        </p>
        <div className='flex flex-col gap-[17px] py-5'>
          {isLoading && [1, 2].map((e) => <AddressOptionSkeleton key={e} />)}

          {!!userAddress?.data?.data?.items?.length &&
            userAddress?.data?.data?.items?.map((e, i) => (
              <HomeDeliveryAddressCard
                setSelectedOption={setSelectedOption}
                selectedOption={selectedOption}
                key={`${i}-${e?.id}`}
                address={e}
                setModalStep={setModalStep}
                setSelectedAddress={setSelectedAddress}
                mutate={mutate}
                setAddressType={setAddressType}
              />
            ))}

          <AddressOption
            icon={PlusIcon}
            label={t('Add New Address')}
            onClick={() => {
              setSelectedOption(SHIPPING_INFO_MODALS_NAMES.ADD_ADDRESS_OPTIONS);
              setModalStep(SHIPPING_INFO_MODALS_NAMES.ADD_ADDRESS_OPTIONS);
              event_new_address();
            }}
            selectedOption={selectedOption}
            code={SHIPPING_INFO_MODALS_NAMES.ADD_ADDRESS_OPTIONS}
          />
          <AddressOption
            icon={ShopIcon}
            label={t('Switch to Store Pickup')}
            onClick={() => {
              event_button_click({
                button_name: 'Switch to Store Pickup',
                button_destination: 'switch_to_store_pickup',
                button_location: 'shipping_modal',
              });
              setSelectedOption(SHIPPING_INFO_MODALS_NAMES.STORE_PICKUP);
              setModalStep(SHIPPING_INFO_MODALS_NAMES.CHOOSE_BRANCH);
              setShippingMethod(SHIPPING_INFO_MODALS_NAMES.STORE_PICKUP);
            }}
            selectedOption={selectedOption}
            code={SHIPPING_INFO_MODALS_NAMES.STORE_PICKUP}
          />
        </div>
      </div>

      <div className='border-t border-t-[#DDDDDD] pb-5 max-sm:px-1.75'>
        <Button
          disabled={!selectedOption?.country_id}
          onClick={() => {
            if (selectedOption?.country_id) {
              setShippingAddress(selectedOption);
              handleOnClose();
            }
          }}
          className='bg-primary mx-auto mt-[15px] flex h-[45px] w-[36.688rem] items-center justify-center rounded-[5px] text-[15px] font-bold text-white max-sm:w-full'
        >
          {t('choose_address')}
        </Button>
      </div>
    </>
  );
};

export default DeliveryAddressModal;

function AddressOption({ icon: Icon, label, onClick, selectedOption, code }) {
  return (
    <div
      onClick={onClick}
      role='button'
      tabIndex={0}
      className={`hover:border-primary flex h-[5.313rem] cursor-pointer items-center justify-between rounded-[10px] border border-gray-200 px-[19px] transition-all duration-150 max-sm:h-16 ${selectedOption == code && 'border-primary'}`}
    >
      <div className='flex h-full items-center gap-[16px]'>
        <div className='flex h-12 w-12 items-center justify-center rounded-full bg-[#F2F3F5]'>
          <Icon className='h-[27px] w-[27px] text-gray-700' />
        </div>
        <h3 className='mb-[2px] text-[16px] font-bold text-gray-900 max-sm:text-sm'>
          {label}
        </h3>
      </div>
    </div>
  );
}
